module.exports = __webpack_public_path__ + "img/about.1fa27de7.png";